import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const StyleUploadButtonWrapper = styled.div<any>`
  border: 1px solid ${(props) => (props?.hasError ? '#EF4444' : '#E2E8F0')};
  border-radius: 6px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  overflow: hidden;
  background: #ffffff;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #94a3b8;
  }
`

export const StyleUploadButton = styled.div<any>`
  background: #3b82f6;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  padding: 0 20px;
  border-radius: 4px;
  font-size: 14px;
  gap: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #2563eb;
  }
`

export const StyleUploadInput = styled.input`
  display: none;
`

export const StyleUploadButtonImgPreview = styled.img`
  width: 50px;
  height: 38px;
  border-radius: 4px;
  object-fit: cover;
`

export const StyleUploadInputWrapper = styled.div<any>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 1px solid ${(props) => (props?.hasError ? '#EF4444' : '#E2E8F0')};
  border-radius: 6px;
  height: 40px;
  padding: 0 2px;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #94a3b8;
  }
`

export const StyleUploadInputFilename = styled.p<any>`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.placeholder};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
`

export const StyleDragUploadWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${(props: any) => props.size}px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px dashed #94a3b8;
  background: #f8fafc;
  overflow: hidden;
  position: relative;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    border-color: #3b82f6;
    background: #f1f5f9;
  }
`

export const StyleVideoWrapper = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`

export const StyleDragImageWrapper = styled.img<any>`
  width: 100%;
  height: ${(props) => props.size}px;
  object-fit: contain;
  min-height: 350px;
  border-radius: 12px;
  transition: all 200ms linear;
  &:hover {
    scale: 1.02;
  }
  @media (max-width: 768px) {
    object-fit: contain;
  }
  ${(props: any) =>
    props.isOgImage &&
    css`
      min-height: 223px;
      height: 150px;
    `}
`

export const StyleButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  width: 100%;
`

export const StyleDragButton = styled.button`
  font-size: 14px;
  font-weight: 400;
  border: 0;
  background: none;
  color: #64748b;
  cursor: pointer;
  text-align: center;
`

export const StyleAvatarWrapper = styled.div<any>`
  width: ${(props: any) => props.size}px;
  height: ${(props: any) => props.size}px;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  border: 1px solid ${(props) => (props?.hasError ? '#EF4444' : '#E2E8F0')};
  overflow: hidden;
`

export const StyleAvatarImage = styled.img<any>`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const StyleIconWrapper = styled.div`
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: #3b82f6;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  z-index: 1;
`

export const StyleBannerUploadWrapper = styled.div<any>`
  width: 100%;
  height: 100%;
  min-height: 380px;
  position: relative;
  border-radius: 12px;
  border: 1px dashed ${(props: any) => props.theme.colors.borderColor};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    border-color: rgba(59, 131, 246, 0.13);
    background: rgba(241, 245, 249, 0.16);
  }
  ${(props: any) =>
    props.isOgImage &&
    css`
      min-height: 0;
      width: 87%;
    `}
`

export const StyleBannerUploadPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #64748b;

  span {
    font-size: 14px;
  }
`
